/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { createRole } from '../fn/dc-role/create-role';
import { CreateRole$Params } from '../fn/dc-role/create-role';
import { DcRoleDto } from '../models/dc-role-dto';
import { deleteRole } from '../fn/dc-role/delete-role';
import { DeleteRole$Params } from '../fn/dc-role/delete-role';
import { getAvailablePermissions } from '../fn/dc-role/get-available-permissions';
import { GetAvailablePermissions$Params } from '../fn/dc-role/get-available-permissions';
import { getRoleById } from '../fn/dc-role/get-role-by-id';
import { GetRoleById$Params } from '../fn/dc-role/get-role-by-id';
import { getRoles } from '../fn/dc-role/get-roles';
import { GetRoles$Params } from '../fn/dc-role/get-roles';
import { modifyRole } from '../fn/dc-role/modify-role';
import { ModifyRole$Params } from '../fn/dc-role/modify-role';

@Injectable({ providedIn: 'root' })
export class DcRoleService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getRoleById()` */
  static readonly GetRoleByIdPath = '/api/roles/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getRoleById()` instead.
   *
   * This method doesn't expect any request body.
   */
  getRoleById$Response(params: GetRoleById$Params, context?: HttpContext): Observable<StrictHttpResponse<DcRoleDto>> {
    return getRoleById(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getRoleById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getRoleById(params: GetRoleById$Params, context?: HttpContext): Observable<DcRoleDto> {
    return this.getRoleById$Response(params, context).pipe(
      map((r: StrictHttpResponse<DcRoleDto>): DcRoleDto => r.body)
    );
  }

  /** Path part for operation `modifyRole()` */
  static readonly ModifyRolePath = '/api/roles/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `modifyRole()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  modifyRole$Response(params: ModifyRole$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return modifyRole(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `modifyRole$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  modifyRole(params: ModifyRole$Params, context?: HttpContext): Observable<void> {
    return this.modifyRole$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `createRole()` */
  static readonly CreateRolePath = '/api/roles/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createRole()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createRole$Response(params: CreateRole$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return createRole(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createRole$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createRole(params: CreateRole$Params, context?: HttpContext): Observable<void> {
    return this.createRole$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `deleteRole()` */
  static readonly DeleteRolePath = '/api/roles/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteRole()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteRole$Response(params: DeleteRole$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return deleteRole(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteRole$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteRole(params: DeleteRole$Params, context?: HttpContext): Observable<void> {
    return this.deleteRole$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `getRoles()` */
  static readonly GetRolesPath = '/api/roles';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getRoles()` instead.
   *
   * This method doesn't expect any request body.
   */
  getRoles$Response(params?: GetRoles$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<DcRoleDto>>> {
    return getRoles(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getRoles$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getRoles(params?: GetRoles$Params, context?: HttpContext): Observable<Array<DcRoleDto>> {
    return this.getRoles$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<DcRoleDto>>): Array<DcRoleDto> => r.body)
    );
  }

  /** Path part for operation `getAvailablePermissions()` */
  static readonly GetAvailablePermissionsPath = '/api/roles/available-permissions';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAvailablePermissions()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAvailablePermissions$Response(params?: GetAvailablePermissions$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<'MANAGE_DIANA' | 'MANAGE_ONLINE_API' | 'MANAGE_TENANT' | 'VIEW_TENANT' | 'MANAGE_ORG_UNIT' | 'VIEW_ORG_UNIT' | 'MANAGE_SETTING' | 'VIEW_SETTING' | 'MANAGE_ROLES' | 'VIEW_ROLES' | 'MANAGE_USERS' | 'VIEW_USERS' | 'MANAGE_APPOINTMENTS' | 'VIEW_APPOINTMENTS' | 'MANAGE_CUSTOMER' | 'VIEW_CUSTOMER' | 'MANAGE_MEDICAL_HISTORY' | 'VIEW_MEDICAL_HISTORY' | 'MANAGE_NEW_CUSTOMER' | 'MANAGE_USERPROFILE'>>> {
    return getAvailablePermissions(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getAvailablePermissions$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAvailablePermissions(params?: GetAvailablePermissions$Params, context?: HttpContext): Observable<Array<'MANAGE_DIANA' | 'MANAGE_ONLINE_API' | 'MANAGE_TENANT' | 'VIEW_TENANT' | 'MANAGE_ORG_UNIT' | 'VIEW_ORG_UNIT' | 'MANAGE_SETTING' | 'VIEW_SETTING' | 'MANAGE_ROLES' | 'VIEW_ROLES' | 'MANAGE_USERS' | 'VIEW_USERS' | 'MANAGE_APPOINTMENTS' | 'VIEW_APPOINTMENTS' | 'MANAGE_CUSTOMER' | 'VIEW_CUSTOMER' | 'MANAGE_MEDICAL_HISTORY' | 'VIEW_MEDICAL_HISTORY' | 'MANAGE_NEW_CUSTOMER' | 'MANAGE_USERPROFILE'>> {
    return this.getAvailablePermissions$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<'MANAGE_DIANA' | 'MANAGE_ONLINE_API' | 'MANAGE_TENANT' | 'VIEW_TENANT' | 'MANAGE_ORG_UNIT' | 'VIEW_ORG_UNIT' | 'MANAGE_SETTING' | 'VIEW_SETTING' | 'MANAGE_ROLES' | 'VIEW_ROLES' | 'MANAGE_USERS' | 'VIEW_USERS' | 'MANAGE_APPOINTMENTS' | 'VIEW_APPOINTMENTS' | 'MANAGE_CUSTOMER' | 'VIEW_CUSTOMER' | 'MANAGE_MEDICAL_HISTORY' | 'VIEW_MEDICAL_HISTORY' | 'MANAGE_NEW_CUSTOMER' | 'MANAGE_USERPROFILE'>>): Array<'MANAGE_DIANA' | 'MANAGE_ONLINE_API' | 'MANAGE_TENANT' | 'VIEW_TENANT' | 'MANAGE_ORG_UNIT' | 'VIEW_ORG_UNIT' | 'MANAGE_SETTING' | 'VIEW_SETTING' | 'MANAGE_ROLES' | 'VIEW_ROLES' | 'MANAGE_USERS' | 'VIEW_USERS' | 'MANAGE_APPOINTMENTS' | 'VIEW_APPOINTMENTS' | 'MANAGE_CUSTOMER' | 'VIEW_CUSTOMER' | 'MANAGE_MEDICAL_HISTORY' | 'VIEW_MEDICAL_HISTORY' | 'MANAGE_NEW_CUSTOMER' | 'MANAGE_USERPROFILE'> => r.body)
    );
  }

}
